import { site } from '@/content/site'
import { backCoverInteriorPhotos, backCoverThanksMessage } from '@/content/printMenu/backCover'
import { BrandNameLockup } from '@/components/printMenu/BrandNameLockup'
import { MenuPageShell } from '@/components/printMenu/MenuPageShell'
import { MenuQrCode } from '@/components/printMenu/MenuQrCode'

type BackCoverPageProps = {
  pageNumber: number
  totalPages: number
}

export function BackCoverPage({ pageNumber, totalPages }: BackCoverPageProps) {
  return (
    <MenuPageShell pageNumber={pageNumber} totalPages={totalPages} hideFooter>
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center px-[14mm] py-[12mm] text-center">
        <BrandNameLockup />
        <p className="mt-4 font-sans text-[length:var(--menu-fs-base)] leading-relaxed text-body">{site.formattedAddress}</p>
        <p className="mt-2 font-sans text-[length:var(--menu-fs-base)] text-muted">{site.phone}</p>
        <p className="mt-2 font-sans text-[length:var(--menu-fs-base)] font-medium text-primary">{site.websiteDisplay}</p>

        <MenuQrCode className="mt-6" />

        <div className="mx-auto mt-8 h-px w-16 bg-hairline" aria-hidden />

        <div className="mt-8 space-y-2 text-center">
          <p className="font-sans text-[length:var(--menu-fs-xs)] font-semibold uppercase tracking-[0.22em] text-muted">
            Hours
          </p>
          {site.hours.map((row) => (
            <p key={row.day} className="font-sans text-[length:var(--menu-fs-base)] text-body">
              <span className="text-muted">{row.day}</span>
              {' · '}
              {row.hours}
            </p>
          ))}
        </div>

        <div className="mt-8 flex w-full max-w-[172mm] gap-[2mm]">
          {backCoverInteriorPhotos.map((photo) => (
            <div key={photo.src} className="min-w-0 flex-1 overflow-hidden rounded-xl">
              <img
                src={photo.src}
                alt={photo.alt}
                className="h-[30mm] w-full rounded-xl object-cover object-center"
              />
            </div>
          ))}
        </div>

        <p className="mt-8 max-w-[120mm] font-display text-[length:var(--menu-fs-md)] font-normal italic leading-[1.65] text-muted">
          {backCoverThanksMessage}
        </p>
      </div>
    </MenuPageShell>
  )
}
